import React from "react";
import { Container, Row, Col } from "react-grid-system";
import Header from "../shared/Header/Header";
import SettingsLeftMenu from "../shared/SettingsLeftMenu/SettingsLeftMenu";
import styles from "./Teams.module.scss";
import { UikDivider } from "@uik";
import TeamsChangeForm from "./TeamsChangeForm";

import { useTranslation } from "react-i18next";

export const Teams = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className={styles.container}>
      <Header />
      <Row className={styles.row}>
        <SettingsLeftMenu />
        <Col sm={12} md={5}>
          <div className={styles.block}>
            <div className={styles.content}>
              <div className={styles.heading}>
                <div>Teams</div>
                <div className={styles.subHeading}>
                  Selecting a team to switch your Papercurve CRM context.
                </div>
              </div>
            </div>
            <UikDivider />
            <TeamsChangeForm />
            <UikDivider />
          </div>
        </Col>
      </Row>
    </Container>
  );
};
